import Router from 'vue-router'
import Vue from 'vue'

// @ts-ignore
import Home from '@/views/home/index'
import CooperationOpportunities from '@/views/cooperationOpportunities/index.vue'
import Product from '@/views/product/index.vue'
import ProductDetail from '@/views/product/productDetail.vue'
import AboutUs from '@/views/aboutUs/index.vue'
import InformationDynamics from '@/views/InformationDynamics/index.vue'
import InformationDynamicsDetail from '@/views/InformationDynamics/detail.vue'
Vue.use(Router);
interface RouteConfig {
    path:string,
    name:string,
    component:any
}

const routes: Array<RouteConfig> = [
    //named routes：动态路由
    {
        path: "/",
        name: "home",
        component: Home
    },
    {
        path: '/product',
        name:'product',
        component: Product
    },
    {
        path: '/productDetail',
        name:'productDetail',
        component: ProductDetail
    },
    {
        path: '/cooperationOpportunities',
        name:'cooperationOpportunities',
        component: CooperationOpportunities
    },
    {
        path: '/aboutUs',
        name:'aboutUs',
        component: AboutUs
    },
    {
        path: '/InformationDynamics',
        name:'InformationDynamics',
        component: InformationDynamics
    },
    {
        path: '/InformationDynamicsDetail',
        name:'InformationDynamicsDetail',
        component: InformationDynamicsDetail
    }

]
const router = new Router({
    mode: 'history',
    routes: routes
})

export default router